<template>
    <SmartLinkItemComponent :id="`_${model.system.id}`" :component="!model.system.workflow" v-if="model">
        <div class="split-content-block-basic" v-if="model">
            <div class="title" v-if="model.elements.title.value">
                <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                    <h2>{{ model.elements.title.value }}</h2>
                </SmartLinkStandaloneElement>   
            </div>       
            <div class="content" v-if="!isEmpty(model?.elements?.content?.value)">
                <SmartLinkStandaloneElement :codename="type.elements.content.codename">
                    <RichText :value="model.elements.content.value" />
                </SmartLinkStandaloneElement>   
            </div>             
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { type SplitContentBlockBasicContentModel, contentTypes } from '~~/app/models';

const type = contentTypes.split_content_block_basic_content;
const props = defineProps<{ model: SplitContentBlockBasicContentModel }>();
</script>